export default function SafetySection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="lg:w-2/5 flex-shrink-0 order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden bg-accent-100">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20security%20trust%20concept%20featuring%20abstract%20geometric%20shield%20shape%20with%20luminous%20warm%20golden%20accents%20on%20soft%20cream%20background%20gentle%20ambient%20lighting%20serene%20professional%20atmosphere%20contemporary%20graphic%20design%20aesthetic%20trustworthy%20sophisticated%20minimal%20composition&width=800&height=800&seq=safety-cssbuy-v3-2026&orientation=squarish"
                alt="CSSBuy Spreadsheet Security"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-3/5 order-1 lg:order-2">
            <span className="inline-block text-foreground-500 text-xs font-medium mb-2">
              (Segurança)
            </span>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.08] tracking-tight">
              Compre com<br />
              <span className="text-foreground-400">total segurança</span>
            </h2>

            <blockquote className="mt-8 border-l-2 border-accent-400 pl-5">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed italic">
                &ldquo;Utilizando o CSSBuy Spreadsheet, conseguimos reduzir drasticamente os casos
                de compras frustradas. Cada link é verificado manualmente pela nossa equipa antes
                de ser adicionado à planilha. Não incluímos vendedores sem histórico comprovado
                ou produtos com avaliações duvidosas. A sua segurança é a nossa prioridade.&rdquo;
              </p>
              <footer className="mt-4 text-sm font-semibold text-foreground-800">
                — Equipa CSSBuy Sheet Portugal
              </footer>
            </blockquote>

            <div className="flex items-center gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Explorar links seguros
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-700 px-6 py-3 rounded-full text-sm font-semibold hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Ver metodologia
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}